import { List } from "immutable";
import * as M from "../models";

export interface PageState {
    pages: List<M.Page.Page>;
    subscribedIds: List<number>;
    statuses: List<M.Page.PageStateStatus>;
}

export const initialState: PageState = {
    pages: List<M.Page.Page>(),
    subscribedIds: List<number>(),
    statuses: List<M.Page.PageStateStatus>(),
};



// WEBPACK FOOTER //
// ./src/store/PageState.ts